export const News1 = [
  {
    lessonNumber: "1",
    lessonTitle: "News Vocabulary Part 1",

    SubTitle1: "K-pop Demon hunters cause controversy",
    PreKoreanWord1: "The songs offended",
    KoreanWord1: "기독교",
    KoreanWord1EngTranslation: "Christianity",
    PostKoreanWord1: "with references to the devil.",

    PreKoreanWord2: "So the songs were banned in a",
    KoreanWord2: "영아",
    KoreanWord2EngTranslation: "baby, infant",
    PostKoreanWord2: "school.",

    PreKoreanWord3: "There's no place in our",
    KoreanWord3: "공동체",
    KoreanWord3EngTranslation: "community",
    PostKoreanWord3: "for this.",

    PreKoreanWord4: "It's harmful to",
    KoreanWord4: "영적",
    KoreanWord4EngTranslation: "spiritual",
    PostKoreanWord4: "development.",

    PreKoreanWord5: "The head wrote a",
    KoreanWord5: "서한",
    KoreanWord5EngTranslation: "a letter",
    PostKoreanWord5: "explaining his views.",

    PreKoreanWord6: "The drama dealt with an",
    KoreanWord6: "여정",
    KoreanWord6EngTranslation: "itinerary",
    PostKoreanWord6: "from good to evil.",

    PreKoreanWord7: "We can't give in to",
    KoreanWord7: "유혹",
    KoreanWord7EngTranslation: "temptation, lure",
    PostKoreanWord7: "and flounder in life.",

    PreKoreanWord8: "We must stick to our",
    KoreanWord8: "신앙",
    KoreanWord8EngTranslation: "faith, religious belief",
    PostKoreanWord8: "and all it asks for.",

    PreKoreanWord9: "There is no",
    KoreanWord9: "상충",
    KoreanWord9EngTranslation: "contradiction",
    PostKoreanWord9: "between this and modern life.",

    PreKoreanWord10: "But the singer was going with the",
    KoreanWord10: "흐름",
    KoreanWord10EngTranslation: "flow, stream",
    PostKoreanWord10: "on this.",

    PreKoreanWord11: "I'm a really",
    KoreanWord11: "익숙",
    KoreanWord11EngTranslation: "skilled, experienced, proficient",
    PostKoreanWord11: "singer and want respect.",

    PreKoreanWord12: "I could never have",
    KoreanWord12: "짐작",
    KoreanWord12EngTranslation: "guess, assume",
    PostKoreanWord12: "it would end up like this.",

    SubTitle13: "Ukrainian soldiers use land drones in combat",
    PreKoreanWord13: "One soldier held his",
    KoreanWord13: "무전기",
    KoreanWord13EngTranslation: "walkie talking",
    PostKoreanWord13: "and spoke to another.",

    PreKoreanWord14: "It was dangerous so he had to",
    KoreanWord14: "속삭이다",
    KoreanWord14EngTranslation: "whisper",
    PostKoreanWord14: ".",

    PreKoreanWord15: "There were several",
    KoreanWord15: "전우",
    KoreanWord15EngTranslation: "comrade in arms",
    PostKoreanWord15: "in this hiding place.",

    PreKoreanWord16: "Everything they do must be done",
    KoreanWord16: "신속하게",
    KoreanWord16EngTranslation: "rapidly",
    PostKoreanWord16: ".",

    PreKoreanWord17: "It's too",
    KoreanWord17: "위태로운",
    KoreanWord17EngTranslation: "risky, dangerous",
    PostKoreanWord17: "to go slow.",

    PreKoreanWord18: "We are within",
    KoreanWord18: "사정권",
    KoreanWord18EngTranslation: "(within) firing range, range (of weapon)",
    PostKoreanWord18: "of Russian drones.",

    PreKoreanWord19: "These soldiers are part of the drone",
    KoreanWord19: "여단",
    KoreanWord19EngTranslation: "brigade",
    PostKoreanWord19: ".",

    PreKoreanWord20: "They have a new",
    KoreanWord20: "장난감",
    KoreanWord20EngTranslation: "toy, plaything",
    PostKoreanWord20: "to use in fighting.",

    PreKoreanWord21: "Trying to hold the",
    KoreanWord21: "요충지",
    KoreanWord21EngTranslation: "strategic point, critical position",
    PostKoreanWord21: "at all costs.",

    PreKoreanWord22: "The",
    KoreanWord22: "보급로",
    KoreanWord22EngTranslation: "supply route",
    PostKoreanWord22: "are too dangerous for regular vehicles.",

    PreKoreanWord23: "All day and night they are",
    KoreanWord23: "거듭",
    KoreanWord23EngTranslation: "again, repeatedly",
    PostKoreanWord23: "attacked by Russia.",

    PreKoreanWord24: "Then, at the",
    KoreanWord24: "제때",
    KoreanWord24EngTranslation: "right time, right moment",
    PostKoreanWord24: "they spring into action.",

    PreKoreanWord25: "If it wasn't for resupply they'd have to",
    KoreanWord25: "항복",
    KoreanWord25EngTranslation: "surrender",
    PostKoreanWord25: "or run.",

    PreKoreanWord26: "But these",
    KoreanWord26: "정예군",
    KoreanWord26EngTranslation: "seasoned troops, crack soldiers",
    PostKoreanWord26: "don't want to lose.",

    PreKoreanWord27: "We're trying our best to",
    KoreanWord27: "장악",
    KoreanWord27EngTranslation: "dominate, seize control",
    PostKoreanWord27: "this area.",

    PreKoreanWord28: "To do that we need",
    KoreanWord28: "보급품",
    KoreanWord28EngTranslation: "supplies (military)",
    PostKoreanWord28: "around the clock.",

    PreKoreanWord29: "The drones don't have a",
    KoreanWord29: "포탑",
    KoreanWord29EngTranslation: "turret (on a tank)",
    PostKoreanWord29: "and can't fire.",

    PreKoreanWord30: "They are also hard to",
    KoreanWord30: "탐지하다",
    KoreanWord30EngTranslation: "detect, locate",
    PostKoreanWord30: "by vision alone.",

    PreKoreanWord31: "They can still be",
    KoreanWord31: "교란",
    KoreanWord31EngTranslation: "disturb",
    PostKoreanWord31: "by aerial drones.",

    PreKoreanWord32: "The land drones are used to bring",
    KoreanWord32: "물자",
    KoreanWord32EngTranslation: "supplies, goods, commodities",
    PostKoreanWord32: "to the troops.",

    PreKoreanWord33: "This really is a",
    KoreanWord33: "접전",
    KoreanWord33EngTranslation: "a close game; engage in battle",
    PostKoreanWord33: "right now.",

    PreKoreanWord34: "One soldier is responsible for",
    KoreanWord34: "조종",
    KoreanWord34EngTranslation: "pilot, fly; manipulate ",
    PostKoreanWord34: "the drone.",

    PreKoreanWord35: "His team",
    KoreanWord35: "이루어지다",
    KoreanWord35EngTranslation: "consist of, composed of; be fulfilled",
    PostKoreanWord35: "several men.",

    PreKoreanWord36: "All the time incoming",
    KoreanWord36: "포탄",
    KoreanWord36EngTranslation: "shell, cannonball",
    PostKoreanWord36: "leave them in fear.",

    PreKoreanWord37: "But this war has gone from",
    KoreanWord37: "재래식 무기",
    KoreanWord37EngTranslation: "conventional weapons",
    PostKoreanWord37: "to a newer drone warfare.",

    PreKoreanWord38: "After evacuation a",
    KoreanWord38: "의무병",
    KoreanWord38EngTranslation: "medic",
    PostKoreanWord38: "can see to the wounded.",

    PreKoreanWord39: "The division",
    KoreanWord39: "회계감사관",
    KoreanWord39EngTranslation: "comptroller (senior accountant)",
    PostKoreanWord39: "is even here on duty.",

    PreKoreanWord40: "I fight for my",
    KoreanWord40: "자국",
    KoreanWord40EngTranslation: " one's homeland; mark, stain, impression",
    PostKoreanWord40: "and won't surrender.",

    PreKoreanWord41: "His last words before",
    KoreanWord41: "후송",
    KoreanWord41EngTranslation: "evacuation",
    PostKoreanWord41: "to the hospital.",

    PreKoreanWord42: "Then,",
    KoreanWord42: "순식간",
    KoreanWord42EngTranslation: "in an instant",
    PostKoreanWord42: "another shell landed.",

    PreKoreanWord43: "We",
    KoreanWord43: "고작",
    KoreanWord43EngTranslation: "only, just, barely, at best",
    PostKoreanWord43: "missed that.",

    PreKoreanWord44: "We were hiding in a",
    KoreanWord44: "민가",
    KoreanWord44EngTranslation: "civilian home, private house",
    PostKoreanWord44: "on the front line.",

    PreKoreanWord45: "But",
    KoreanWord45: "연이어",
    KoreanWord45EngTranslation: "continuously",
    PostKoreanWord45: "we came under fire.",

    PreKoreanWord46: "We",
    KoreanWord46: "숨다",
    KoreanWord46EngTranslation: "to hide",
    PostKoreanWord46: "in houses and foliage.",

    PreKoreanWord47: "But still danger",
    KoreanWord47: "도사린다",
    KoreanWord47EngTranslation: "to lurk in",
    PostKoreanWord47: "every corner.",

    PreKoreanWord48: "The",
    KoreanWord48: "덤불",
    KoreanWord48EngTranslation: "bush, thicket",
    PostKoreanWord48: "doesn't provide much protection.",

    PreKoreanWord49: "There is a quiet moment, at",
    KoreanWord49: "전속력",
    KoreanWord49EngTranslation: "full speed",
    PostKoreanWord49: "we run for cover.",

    PreKoreanWord50: "Then we pilot a",
    KoreanWord50: "일인칭",
    KoreanWord50EngTranslation: "the first person (viewpoint)",
    PostKoreanWord50: "drone towards us.",
  },
];
